// extracted by mini-css-extract-plugin
module.exports = {"root":"detail-label_root__0GfQi"};